"use client";
import React from "react";
import Table from "@/components/primitives/table";
import { ColumnDef } from "@tanstack/react-table";
import { Roster, Sport } from "common";
import Link from "next/link";
import { createPlayerProfileSlug } from "@/utils/url";
import Button from "../primitives/button";

export default function TeamRosterTable({
  sport,
  data,
}: {
  sport: Sport;
  data: Roster[];
}) {
  const columns: ColumnDef<Roster>[] = React.useMemo(
    () => [
      {
        header: "Player",
        accessorKey: "name",
        enableSorting: true,
        accessorFn: (info) => {
          return `${info.firstName} ${info.lastName}`;
        },
        cell: (info) => {
          return (
            <Button
            unstyled
              href={createPlayerProfileSlug(sport, info.row.original.id)}
              className="flex flex-row gap-1 py-3"
            >
              {`${info.getValue()}`}
            </Button>
          );
        },
      },
      {
        header: "NO",
        accessorKey: "number",
        enableSorting: true,
      },
      {
        header: "P",
        accessorKey: "position",
        enableSorting: true,
      },
      {
        header: "HT",
        accessorKey: "height",
      },
      {
        header: "WT (LBS)",
        accessorKey: "weight",
      },
      {
        header: "Age",
        accessorKey: "age",
      },
      // {
      //   header: "Exp",
      //   accessorFn: (info) => {
      //       return formatEmptyState("empty");
      //   }
      // },
      {
        header: "Birth Place",
        accessorKey: "birthPlace",
        enableSorting: false,
      },
      // {
      //   header: "College",
      //   accessorFn: (info) => {
      //     if (isEmpty(info.college)) {
      //       return formatEmptyState("empty");
      //     }
      //   }
      // },
    ],
    []
  );
  return <Table columns={columns} data={data} type="banded" />;
}
